import React from 'react'
import { FormGroup, Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap'
import FlexCol from '../Common/FlexCol'
import { Flex } from 'antd'
import DateSelect from '../Common/DateSelector'
import FormInput from '../Common/FormInput'
import CommonButton from '../Common/Button'

function NewStockEntry({ isOpen, toggle }) {
    return (
        <Offcanvas isOpen={isOpen} toggle={toggle} direction="end"  className="!w-[320px] 2xl:!w-[480px]  max-h-full overflow-y-auto"    >
            <FlexCol className={"p-4"} >

                <OffcanvasHeader >
                    <div >
                        <div className="text-[16px] font-semibold 2xl:text-2xl text-[#09090B]  leading-[21.6px] break-words font-plus-jakarta-sans">New Stock Entry</div>
                        <div className="text-[10px] 2xl:text-sm  text-[#726C6C] font-plus-jakarta-sans ">Enter stock details and quantities.</div>
                    </div>
                </OffcanvasHeader>
                <OffcanvasBody >
                    <FormGroup>
                        <FlexCol className={""} gap={20}>
                            <Flex className="grid grid-cols-1 gap-[30px] items-center">


                                <FormInput title='Feed Name  ' placeholder='Q1 QUALITY' />
                                <DateSelect title='Expiry Date' placeholder='04 Oct 2024' />

                                <FormInput title='Quantity  ' placeholder='5.3 Kilograms' />


                            </Flex>
                        </FlexCol>
                    </FormGroup>
                    <div className=" flex justify-between mt-8 ">
                        <CommonButton
                            style={{ fontSize: "12px", backgroundColor: "none", color: "#726C6C", border: "1px #CCCBCB solid ", marginRight: "8px" }}
                            onClick={toggle}
                            outline
                            title='Discard'
                        />



                        <CommonButton title='Save Delivery' style={{ fontSize: "12px" }} />


                    </div>
                </OffcanvasBody>

            </FlexCol>
        </Offcanvas>
    )
}

export default NewStockEntry